import {
  Airplane,
  Backpack,
  Bed,
  Bicycle,
  BookOpen,
  Broom,
  Cake,
  Calendar,
  Car,
  Cat,
  Check,
  Coins,
  CookingPot,
  Dog,
  Exam,
  FilmSlate,
  ForkKnife,
  GameController,
  Gift,
  GraduationCap,
  Heart,
  Horse,
  IceCream,
  Leaf,
  Lego,
  MoonStars,
  MusicNotes,
  Newspaper,
  PaintBrush,
  Phone,
  Pizza,
  Plant,
  Recycle,
  ShoppingCart,
  Shower,
  SoccerBall,
  Star,
  Stethoscope,
  SwimmingPool,
  Television,
  Tooth,
  Trash,
  Tree,
  TShirt,
  UsersThree,
  Warning,
  WashingMachine,
  type Icon,
} from '@phosphor-icons/react';
import type { IconKey } from '@shh/shared';

/** Pictures for the keys stored in Firestore (see @shh/shared iconKeys). */
const MAP: Record<IconKey, Icon> = {
  check: Check,
  shirt: TShirt,
  tooth: Tooth,
  backpack: Backpack,
  bed: Bed,
  broom: Broom,
  book: BookOpen,
  fork: ForkKnife,
  trash: Trash,
  plant: Plant,
  car: Car,
  dish: CookingPot,
  toy: Lego,
  moon: MoonStars,
  tv: Television,
  pizza: Pizza,
  icecream: IceCream,
  film: FilmSlate,
  game: GameController,
  ball: SoccerBall,
  horse: Horse,
  doctor: Stethoscope,
  tree: Tree,
  school: GraduationCap,
  cake: Cake,
  exam: Exam,
  meeting: UsersThree,
  calendar: Calendar,
  cart: ShoppingCart,
  money: Coins,
  dog: Dog,
  cat: Cat,
  music: MusicNotes,
  swim: SwimmingPool,
  bike: Bicycle,
  shower: Shower,
  laundry: WashingMachine,
  gift: Gift,
  plane: Airplane,
  phone: Phone,
  paint: PaintBrush,
  heart: Heart,
  star: Star,
  recycle: Recycle,
  paper: Newspaper,
  bio: Leaf,
  leaf: Leaf,
  warning: Warning,
};

/** Unknown keys (older data, typos) fall back to a neutral check mark. */
export const iconFor = (key?: string): Icon => MAP[key as IconKey] ?? Check;
